<h3 class="text-center">{{'label.verifyNumber' | translate}}:</h3>
<p class="text-center">{{'text.confirm2faSmsParagraph' | translate}}</p>
<h4
  *ngIf="ofuscatedPhone"
  class="text-center"
>{{ofuscatedPhone}}</h4>
<form
  #confirmPhoneForm="ngForm"
  (ngSubmit)="submit(confirmPhoneForm)"
  novalidate
>
  <p
    *ngIf="error"
    class="alert alert-danger"
  >{{error}}</p>

  <div
    class="mb-3"
    [podValidationClass]="confirmation"
  >
    <label
      for="confirmation"
      class="form-label"
    >{{'label.enterCode' | translate}}</label>
    <input
      type="password"
      class="form-control"
      id="confirmation"
      name="confirmation"
      [(ngModel)]="model.confirmation"
      #confirmation="ngModel"
      required
    />
    <pod-validation-messages [model]="confirmation"></pod-validation-messages>
    <p class="form-text text-end"><a
        class="cursor-pointer"
        (click)="repeatCode(confirmPhoneForm)"
        id="confirm-2fa-resend-code"
      >{{'label.resendCode' | translate}}</a></p>
  </div>
  <div [ngClass]="{'d-flex justify-content-around align-items-center': !blockButtons, 'd-grid gap-3': blockButtons}">
    <button
      type="submit"
      class="btn btn-tertiary"
      [disabled]="submitting"
      id="confirm-2fa-submit"
    >
      {{ (submitting ? 'label.saving...' : 'label.verifyNumber') | translate}}
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="onCancel.emit()"
      id="confirm-2fa-cancel"
    >{{'label.cancel' | translate}}</button>
  </div>
</form>
